<template>
  <div v-if="loading" class="loader">
    <b-spinner
      variant="primary"
      type="grow"
      :label="`${this.$t('reports.loadingLabel')}...`"
    ></b-spinner>
  </div>
  <div
    v-else
    id="categoriesReport"
    class="card px-2 py-2 mt-3 wrapper-categories"
  >
    <div class="col-12" style="display: flex">
      <button
        class="btn pull-left text-left col-6"
        style="box-shadow: none"
        @click="visible = !visible"
      >
        {{ this.$t('reports.categories.reportTitle') }}
      </button>
      <div class="pull-right text-right col-5">
        <div v-if="categoriesAnalysis" style="display: flex; float: right">
          <b-form-radio-group
            id="type-radio-group"
            name="radio-calculation"
            :value="categoryOption"
            v-model="categoryOption"
            style="white-space: nowrap"
          >
            <div class="optionA">
              <b-form-radio name="frequency-radio" value="true">
                {{ this.$t('reports.categories.frequencyOption') }}
              </b-form-radio>
            </div>
            <div class="optionB">
              <b-form-radio name="answer-radio" value="false">
                {{ this.$t('reports.categories.normalOption') }}
              </b-form-radio>
            </div>
          </b-form-radio-group>

          <font-awesome-icon
            id="category-option-info"
            :icon="['fas', 'info-circle']"
            style="font-size: 15px; color: #c1c1c1"
          />
          <b-popover
            target="category-option-info"
            triggers="hover"
            placement="bottom"
          >
            <b>Categoria (base frequência)</b> - Cálculo: Categoria / Total de
            categorias.<br />
            <br />
            <b>Categoria (base respostas)</b> - Cálculo: Categoria / Total de
            respostas.
          </b-popover>
        </div>
      </div>
      <button
        class="btn pull-right col-1 text-right"
        style="box-shadow: none"
        @click="visible = !visible"
      >
        <i class="fas fa-angle-double-right" v-if="!visible"></i>
        <i v-else class="fas fa-angle-double-down"></i>
      </button>
    </div>
    <div>
      <b-collapse v-model="visible" class="mt-2">
        <b-table
          v-if="generalItems.qtd > 0"
          :items="generalItems.items"
          :fields="fieldsGeneral"
        >
          <template #cell(show_details)="row">
            <!--
            <i
              v-if="row.item.subCategories.length > 0"
              class="fas fa-angle-double-right"
              :on-icon="'mdi-heart'"
              :off-icon="'mdi-home'"
            ></i>
            -->
            <b-form-checkbox
              v-if="row.item.subCategories.length > 0"
              v-model="row.detailsShowing"
              @change="row.toggleDetails"
            >
            </b-form-checkbox>
          </template>
          <template #cell(id)="row">
            {{ getCategoryName(row.item.id) }}
          </template>
          <template #cell(progress)="row">
            <div class="mt-2" style="width: 100%">
              <b-progress
                variant="info"
                :value="Math.round((row.item.qtd / generalItems.qtd) * 100)"
                :max="100"
              ></b-progress>
            </div>
          </template>
          <template #cell(score)="row">
            <div class="text-center">
              {{ Math.round((row.item.qtd / generalItems.qtd) * 100) }}%
            </div>
          </template>
          <template #row-details="row">
            <div class="col-12 subHeader">
              {{ $t('reports.categories.subcategories') }}:
            </div>
            <div v-for="(sub, index) in row.item.subCategories" :key="index.id">
              <b-row class="subLine">
                <div class="questionSub text-right">
                  {{ getSubCategoryName(sub.id) }}
                </div>
                <div class="progressSub">
                  <b-progress
                    variant="info"
                    :value="Math.round((sub.qtd / row.item.qtd) * 100)"
                    :max="100"
                  ></b-progress>
                </div>
                <div v-if="categoryOption" class="catColumnSub">
                  {{ Math.round((sub.qtd / generalItems.qtd) * 100) }}% /
                  {{ sub.qtd }}
                </div>
                <div v-else class="catColumnSub">
                  {{ Math.round((sub.qtd / row.item.qtd) * 100) }}% /
                  {{ sub.qtd }}
                </div>
              </b-row>
            </div>
          </template>
        </b-table>
        <div v-if="generalItems.qtd > 0" class="col-12 text-right mb-3 pr25">
          {{ categoryLabel }}:
          {{ generalItems.qtd }}
        </div>
        <hr />
        <b-table
          v-if="promoters.qtd > 0"
          :items="promoters.items"
          :fields="fieldsPromoter"
        >
          <template #cell(show_details)="row">
            <b-form-checkbox
              v-if="row.item.subCategories.length > 0"
              v-model="row.detailsShowing"
              @change="row.toggleDetails"
            >
            </b-form-checkbox>
          </template>
          <template #cell(id)="row">
            {{ getCategoryName(row.item.id) }}
          </template>
          <template #cell(progress)="row">
            <div class="mt-2" style="width: 100%">
              <b-progress
                :value="Math.round((row.item.qtd / promoters.qtd) * 100)"
                :max="100"
              ></b-progress>
            </div>
          </template>
          <template #cell(score)="row">
            <div class="text-center">
              {{ Math.round((row.item.qtd / promoters.qtd) * 100) }}%
            </div>
          </template>
          <template #row-details="row">
            <div class="col-12 subHeader">
              {{ $t('reports.categories.subcategories') }}:
            </div>
            <div v-for="(sub, index) in row.item.subCategories" :key="index.id">
              <b-row class="subLine">
                <div class="questionSub text-right">
                  {{ getSubCategoryName(sub.id) }}
                </div>
                <div class="progressSub">
                  <b-progress
                    :value="Math.round((sub.qtd / row.item.qtd) * 100)"
                    :max="100"
                  ></b-progress>
                </div>
                <div v-if="categoryOption" class="catColumnSub">
                  {{ Math.round((sub.qtd / promoters.qtd) * 100) }}% /
                  {{ sub.qtd }}
                </div>
                <div v-else class="catColumnSub">
                  {{ Math.round((sub.qtd / row.item.qtd) * 100) }}% /
                  {{ sub.qtd }}
                </div>
              </b-row>
            </div>
          </template>
        </b-table>
        <div v-if="promoters.qtd > 0" class="col-12 text-right mb-3 pr25">
          {{ categoryLabel }}:
          {{ promoters.qtd }}
        </div>
        <hr />
        <b-table
          v-if="passives.qtd > 0"
          :items="passives.items"
          :fields="fieldsPassive"
        >
          <template #cell(show_details)="row">
            <b-form-checkbox
              v-if="row.item.subCategories.length > 0"
              v-model="row.detailsShowing"
              @change="row.toggleDetails"
            >
            </b-form-checkbox>
          </template>
          <template #cell(id)="row">
            {{ getCategoryName(row.item.id) }}
          </template>
          <template #cell(progress)="row">
            <div class="mt-2" style="width: 100%">
              <b-progress
                variant="warning"
                :value="Math.round((row.item.qtd / passives.qtd) * 100)"
                :max="100"
              ></b-progress>
            </div>
          </template>
          <template #cell(score)="row">
            <div class="text-center">
              {{ Math.round((row.item.qtd / passives.qtd) * 100) }}%
            </div>
          </template>
          <template #row-details="row">
            <div class="col-12 subHeader">
              {{ $t('reports.categories.subcategories') }}:
            </div>
            <div v-for="(sub, index) in row.item.subCategories" :key="index.id">
              <b-row class="subLine">
                <div class="questionSub text-right">
                  {{ getSubCategoryName(sub.id) }}
                </div>
                <div class="progressSub">
                  <b-progress
                    variant="warning"
                    :value="Math.round((sub.qtd / row.item.qtd) * 100)"
                    :max="100"
                  ></b-progress>
                </div>
                <div v-if="categoryOption" class="catColumnSub">
                  {{ Math.round((sub.qtd / passives.qtd) * 100) }}% /
                  {{ sub.qtd }}
                </div>
                <div v-else class="catColumnSub">
                  {{ Math.round((sub.qtd / row.item.qtd) * 100) }}% /
                  {{ sub.qtd }}
                </div>
              </b-row>
            </div>
          </template>
        </b-table>
        <div v-if="passives.qtd > 0" class="col-12 text-right mb-3 pr25">
          {{ categoryLabel }}:
          {{ passives.qtd }}
        </div>
        <hr />
        <b-table
          v-if="detractors.qtd > 0"
          :items="detractors.items"
          :fields="fieldsDetractor"
        >
          <template #cell(show_details)="row">
            <b-form-checkbox
              v-if="row.item.subCategories.length > 0"
              v-model="row.detailsShowing"
              @change="row.toggleDetails"
            >
            </b-form-checkbox>
          </template>
          <template #cell(id)="row">
            {{ getCategoryName(row.item.id) }}
          </template>
          <template #cell(progress)="row">
            <div class="mt-2" style="width: 100%">
              <b-progress
                variant="danger"
                :value="Math.round((row.item.qtd / detractors.qtd) * 100)"
                :max="100"
              ></b-progress>
            </div>
          </template>
          <template #cell(score)="row">
            <div class="text-center">
              {{ Math.round((row.item.qtd / detractors.qtd) * 100) }}%
            </div>
          </template>
          <template #row-details="row">
            <div class="col-12 subHeader">
              {{ $t('reports.categories.subcategories') }}:
            </div>
            <div v-for="(sub, index) in row.item.subCategories" :key="index.id">
              <b-row class="subLine">
                <div class="questionSub text-right">
                  {{ getSubCategoryName(sub.id) }}
                </div>
                <div class="progressSub">
                  <b-progress
                    variant="danger"
                    :value="Math.round((sub.qtd / row.item.qtd) * 100)"
                    :max="100"
                  ></b-progress>
                </div>
                <div v-if="categoryOption" class="catColumnSub">
                  {{ Math.round((sub.qtd / detractors.qtd) * 100) }}% /
                  {{ sub.qtd }}
                </div>
                <div v-else class="catColumnSub">
                  {{ Math.round((sub.qtd / row.item.qtd) * 100) }}% /
                  {{ sub.qtd }}
                </div>
              </b-row>
            </div>
          </template>
        </b-table>
        <div v-if="detractors.qtd > 0" class="col-12 text-right mb-3 pr25">
          {{ categoryLabel }}:
          {{ detractors.qtd }}
        </div>
        <hr />
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import api from '../../../../../services/api';
// import eventBus from '../../../../../eventBus';

export default {
  name: 'ScoreCsat',
  data: () => ({
    userAuth: null,
    visible: true,
    total: 0,
    page: 1,
    limit: 10,
    // dates: {
    //   start: null,
    //   end: null,
    // },
    generalItems: { qtd: 0 },
    promoters: {},
    passives: {},
    detractors: {},
    categories: [],
    subCategories: [],
    subcategory_generalItems: {},
    subcategory_promoters: {},
    subcategory_passives: {},
    subcategory_detractors: {},
    fieldsGeneral: [],
    fieldsPromoter: [],
    fieldsPassive: [],
    fieldsDetractor: [],
    promoterLabel: '',
    neutralLabel: '',
    detractorLabel: '',
    categoriesAnalysis: false,
    categoryOption: false,
    categoryLabel: '',
    loading: false,
  }),
  watch: {
    actionGroupData: function watchActionGroupData() {
      this.setData();
    },
    myMetric: function watchMyMetric() {
      this.changeLabel();
      this.setData();
      this.changeLabel();
    },
    myActionId: function watchMyActionId() {
      this.setData();
    },
    myActionsIds: function watchMyActionsIds() {
      this.setData();
    },
    myIh1: function watchMyIh1() {
      this.setData();
    },
    myHierarchies1: function watchMyHierarchies1(){
      this.setData();
    },
    myIh2: function watchMyIh2() {
      this.setData();
    },
    myHierarchies2: function watchMyHierarchies2(){
      this.setData();
    },
    calendarDates: function watchDates() {
      this.setData();
    },
    'indicatorData.value': function watchindicatorData() {
      this.setData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.setData();
    },
    categoryOption: function watchCategoryOption() {
      this.setData();
    },
  },
  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('charts', ['reportCategories']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },
  methods: {
    ...mapActions('charts', ['getReportCategories']),
    ...mapActions('calendar'),
    changeCategoryOption() {
      this.categoryOption = !this.categoryOption;
    },
    async setData() {
      this.loading = true;
      await this.getReportCategories({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        page: this.page,
        limit: this.limit,
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
        metric: this.myMetric,
        frequencyOption: this.categoryOption,
      });
      this.generalItems = this.reportCategories.generalItems;
      this.promoters = this.reportCategories.promoters;
      this.passives = this.reportCategories.passives;
      this.detractors = this.reportCategories.detractors;
      // subCategories
      this.subcategory_generalItems =
        this.reportCategories.subcategory_generalItems;
      this.subcategory_promoters = this.reportCategories.subcategory_promoters;
      this.subcategory_passives = this.reportCategories.subcategory_passives;
      this.subcategory_detractors =
        this.reportCategories.subcategory_detractors;
      // change lists for adding subcategories array
      const generalItens = await this.fixList(
        this.generalItems.items,
        'general',
      );
      const promoterItens = await this.fixList(
        this.promoters.items,
        'promoter',
      );
      const passiveItens = await this.fixList(this.passives.items, 'passive');
      const detractorItens = await this.fixList(
        this.detractors.items,
        'detractor',
      );
      this.generalItems = {
        qtd: this.generalItems.qtd,
        items: generalItens,
      };
      this.promoters = {
        qtd: this.promoters.qtd,
        items: promoterItens,
      };
      this.passives = {
        qtd: this.passives.qtd,
        items: passiveItens,
      };
      this.detractors = {
        qtd: this.detractors.qtd,
        items: detractorItens,
      };
      if (this.categoryOption) {
        this.categoryLabel = this.$t('reports.categories.totalCategories');
      } else {
        this.categoryLabel = this.$t('reports.categories.totalCategorized');
      }
      this.loading = false;
    },
    fixList(list, type) {
      const newList = [];
      // eslint-disable-next-line
      for (const prop in list) {
        const hasSubcategories = this.hasSubCategory(prop, type);
        let subCategories = [];
        if (hasSubcategories) {
          subCategories = this.buildSubcategoriesList(prop, type);
        }
        const obj = {
          id: prop,
          qtd: list[prop],
          hasSubcategories,
          subCategories,
        };
        newList.push(obj);
      }
      return newList;
    },
    async getCustomCategoriesAnalysis() {
      try {
        const response = await api.get('/categories-analysis', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
        this.categoriesAnalysis = response.data.customCategoriesAnalysis;
        if (this.categoriesAnalysis) {
          this.categoryOption = true;
        }
      } catch (error) {
        window.console.log(error);
      }
    },
    async getCategories() {
      try {
        const response = await api.get('/categories', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
        this.categories = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },
    async getSubCategories() {
      try {
        const response = await api.get('/all-subcategories', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
        this.subCategories = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },
    getCategoryName(id) {
      for (let i = 0; i < this.categories.length; i += 1) {
        if (id === this.categories[i]._id) {
          return this.categories[i].name;
        }
      }
      return '';
    },
    getSubCategoryName(id) {
      for (let i = 0; i < this.subCategories.length; i += 1) {
        if (id === this.subCategories[i]._id) {
          return this.subCategories[i].name;
        }
      }
      return '';
    },
    hasSubCategory(item, type) {
      switch (type) {
        case 'general':
          if (
            this.subcategory_generalItems &&
            this.subcategory_generalItems.items
          ) {
            // eslint-disable-next-line
            for (let prop in this.subcategory_generalItems.items) {
              for (let j = 0; j < this.subCategories.length; j += 1) {
                if (
                  prop === this.subCategories[j]._id &&
                  this.subCategories[j].mainCategoryId === item
                ) {
                  return true;
                }
              }
            }
          }
          break;
        case 'promoter':
          if (this.subcategory_promoters && this.subcategory_promoters.items) {
            // eslint-disable-next-line
            for (let prop in this.subcategory_promoters.items) {
              for (let j = 0; j < this.subCategories.length; j += 1) {
                if (
                  prop === this.subCategories[j]._id &&
                  this.subCategories[j].mainCategoryId === item
                ) {
                  return true;
                }
              }
            }
          }
          break;
        case 'passive':
          if (this.subcategory_passives && this.subcategory_passives.items) {
            // eslint-disable-next-line
            for (let prop in this.subcategory_passives.items) {
              for (let j = 0; j < this.subCategories.length; j += 1) {
                if (
                  prop === this.subCategories[j]._id &&
                  this.subCategories[j].mainCategoryId === item
                ) {
                  return true;
                }
              }
            }
          }
          break;
        case 'detractor':
          if (
            this.subcategory_detractors &&
            this.subcategory_detractors.items
          ) {
            // eslint-disable-next-line
            for (let prop in this.subcategory_detractors.items) {
              for (let j = 0; j < this.subCategories.length; j += 1) {
                if (
                  prop === this.subCategories[j]._id &&
                  this.subCategories[j].mainCategoryId === item
                ) {
                  return true;
                }
              }
            }
          }
          break;
        default:
          break;
      }
      return false;
    },
    buildSubcategoriesList(item, type) {
      const subCategoriesList = [];
      switch (type) {
        case 'general':
          // eslint-disable-next-line
          for (let prop in this.subcategory_generalItems.items) {
            for (let j = 0; j < this.subCategories.length; j += 1) {
              if (
                prop === this.subCategories[j]._id &&
                this.subCategories[j].mainCategoryId === item
              ) {
                subCategoriesList.push({
                  id: prop,
                  qtd: this.subcategory_generalItems.items[prop],
                });
              }
            }
          }
          break;
        case 'promoter':
          // eslint-disable-next-line
          for (let prop in this.subcategory_promoters.items) {
            for (let j = 0; j < this.subCategories.length; j += 1) {
              if (
                prop === this.subCategories[j]._id &&
                this.subCategories[j].mainCategoryId === item
              ) {
                subCategoriesList.push({
                  id: prop,
                  qtd: this.subcategory_promoters.items[prop],
                });
              }
            }
          }
          break;
        case 'passive':
          // eslint-disable-next-line
          for (let prop in this.subcategory_passives.items) {
            for (let j = 0; j < this.subCategories.length; j += 1) {
              if (
                prop === this.subCategories[j]._id &&
                this.subCategories[j].mainCategoryId === item
              ) {
                subCategoriesList.push({
                  id: prop,
                  qtd: this.subcategory_passives.items[prop],
                });
              }
            }
          }
          break;
        case 'detractor':
          // eslint-disable-next-line
          for (let prop in this.subcategory_detractors.items) {
            for (let j = 0; j < this.subCategories.length; j += 1) {
              if (
                prop === this.subCategories[j]._id &&
                this.subCategories[j].mainCategoryId === item
              ) {
                subCategoriesList.push({
                  id: prop,
                  qtd: this.subcategory_detractors.items[prop],
                });
              }
            }
          }
          break;
        default:
          break;
      }
      return subCategoriesList;
    },
    changeLabel() {
      if (this.myMetric.indexOf('nps') !== -1) {
        this.promoterLabel = this.$t('reports.promoterLabel');
        this.neutralLabel = this.$t('reports.neutralLabel');
        this.detractorLabel = this.$t('reports.detractorLabel');
      } else if (this.myMetric === 'like-dislike') {
        this.promoterLabel = 'Like';
        this.neutralLabel = '';
        this.detractorLabel = 'Dislike';
      } else {
        this.promoterLabel = '4-5';
        this.neutralLabel = '3';
        this.detractorLabel = '1-2';
      }

      this.fieldsPromoter = [
        {
          key: 'show_details',
          label: '',
          class: 'column2',
        },
        {
          key: 'id',
          label: this.promoterLabel,
          class: 'questionTh',
        },
        {
          key: 'progress',
          label: '',
          class: 'progressTh',
        },
        {
          key: 'score',
          label: this.$t('reports.categories.scorelabel'),
          class: 'catColumn',
        },
        {
          key: 'qtd',
          label: this.$t('reports.categories.totalLabel'),
          class: 'catColumn',
        },
      ];

      this.fieldsPassive = [
        {
          key: 'show_details',
          label: '',
          class: 'column2',
        },
        {
          key: 'id',
          label: this.neutralLabel,
          class: 'questionTh',
        },
        {
          key: 'progress',
          label: '',
          class: 'progressTh',
        },
        {
          key: 'score',
          label: this.$t('reports.categories.scorelabel'),
          class: 'catColumn',
        },
        {
          key: 'qtd',
          label: this.$t('reports.categories.totalLabel'),
          class: 'catColumn',
        },
      ];

      this.fieldsDetractor = [
        {
          key: 'show_details',
          label: '',
          class: 'column2',
        },
        {
          key: 'id',
          label: this.detractorLabel,
          class: 'questionTh',
        },
        {
          key: 'progress',
          label: '',
          class: 'progressTh',
        },
        {
          key: 'score',
          label: this.$t('reports.categories.scorelabel'),
          class: 'catColumn',
        },
        {
          key: 'qtd',
          label: this.$t('reports.categories.totalLabel'),
          class: 'catColumn',
        },
      ];
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    if (this.myMetric.indexOf('nps') !== -1) {
      this.promoterLabel = this.$t('reports.promoterLabel');
      this.neutralLabel = this.$t('reports.neutralLabel');
      this.detractorLabel = this.$t('reports.detractorLabel');
    } else if (this.myMetric === 'like-dislike') {
      this.promoterLabel = 'Like';
      this.neutralLabel = '';
      this.detractorLabel = 'Dislike';
    } else {
      this.promoterLabel = '4-5';
      this.neutralLabel = '3';
      this.detractorLabel = '1-2';
    }
    this.fieldsGeneral = [
      {
        key: 'show_details',
        label: '',
        class: 'column2',
      },
      {
        key: 'id',
        label: this.$t('reports.categories.allCategories'),
        class: 'questionTh',
      },
      {
        key: 'progress',
        label: '',
        class: 'progressTh',
      },
      {
        key: 'score',
        label: this.$t('reports.categories.scorelabel'),
        class: 'catColumn',
      },
      {
        key: 'qtd',
        label: this.$t('reports.categories.totalLabel'),
        class: 'catColumn',
      },
    ];
    this.fieldsPromoter = [
      {
        key: 'show_details',
        label: '',
        class: 'column2',
      },
      {
        key: 'id',
        label: this.promoterLabel,
        class: 'questionTh',
      },
      {
        key: 'progress',
        label: '',
        class: 'progressTh',
      },
      {
        key: 'score',
        label: this.$t('reports.categories.scorelabel'),
        class: 'catColumn',
      },
      {
        key: 'qtd',
        label: this.$t('reports.categories.totalLabel'),
        class: 'catColumn',
      },
    ];
    this.fieldsPassive = [
      {
        key: 'show_details',
        label: '',
        class: 'column2',
      },
      {
        key: 'id',
        label: this.neutralLabel,
        class: 'questionTh',
      },
      {
        key: 'progress',
        label: '',
        class: 'progressTh',
      },
      {
        key: 'score',
        label: this.$t('reports.categories.scorelabel'),
        class: 'catColumn',
      },
      {
        key: 'qtd',
        label: this.$t('reports.categories.totalLabel'),
        class: 'catColumn',
      },
    ];
    this.fieldsDetractor = [
      {
        key: 'show_details',
        label: '',
        class: 'column2',
      },
      {
        key: 'id',
        label: this.detractorLabel,
        class: 'questionTh',
      },
      {
        key: 'progress',
        label: '',
        class: 'progressTh',
      },
      {
        key: 'score',
        label: this.$t('reports.categories.scorelabel'),
        class: 'catColumn',
      },
      {
        key: 'qtd',
        label: this.$t('reports.categories.totalLabel'),
        class: 'catColumn',
      },
    ];
  },
  async mounted() {
    await this.getCustomCategoriesAnalysis();
    await this.getCategories();
    await this.getSubCategories();
    await this.setData();
    // eventBus.$on('change-dates', (dates) => {
    //   this.dates = dates;
    //   this.setData(this.dates);
    // });
  },
  async beforeDestroy() {
    // eventBus.$off('change-dates');
  },
};
</script>

<style lang="scss">
.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-categories .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-categories .btn .btn-light .collapsed {
  background-color: transparent;
}
.catColumn {
  width: 70px;
  text-align: center;
}
.progressTh {
  width: 20%;
}
.questionTh {
  width: 75%;
}
.column2 {
  width: 2%;
  min-width: 50px;
}
.questionSub {
  width: 30%;
  padding-right: 10px;
}
.progressSub {
  width: 10%;
}
.catColumnSub {
  font-weight: bold;
  padding: 0 10px;
}
.pr25 {
  padding-right: 25px;
}
.progressSub .progress {
  background-color: white;
  margin-top: 4px;
}
.subLine {
  background: #eee;
  padding: 5px;
  border: solid 1px white;
}
.subHeader {
  font-weight: bold;
  padding-left: 30%;
}
#categoriesReport input[type='checkbox'] + label::before {
  content: '\f0fe';
  font-family: FontAwesome;
  display: inline-block;
  padding-right: 5px;
  color: #4ce595;
  border: none;
  margin-top: -5px;
}
#categoriesReport input[type='checkbox']:checked + label::before {
  content: '\f146';
  margin-top: -5px;
  color: #4ce595 !important;
  background-color: white !important;
  z-index: 1;
}
#categoriesReport input {
  display: none;
}
.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-category {
  color: white !important;
  background-color: #4ce595 !important;
  border: 1px solid #4ce595;
}
.optionA,
.optionB {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/categories/index.vue